import script from "./document-preview-viewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./document-preview-viewer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__